import React, { Component } from "react";
import GoogleMapReact from "google-map-react";

// Componente para o marcador
const Marker = ({ onClick }) => (
    <div
        onClick={onClick}
        style={{
            color: "red",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "20px",
            transform: "translate(-50%, -100%)"
        }}
        title="Clique para detalhes"
    >
        ●
    </div>
);

// Componente para o InfoWindow
const InfoWindow = ({ spd, dt }) => {
    // Converte o timestamp para data/hora local
    const dateObj = new Date(dt);
    const formattedDate = dateObj.toLocaleDateString();
    const formattedTime = dateObj.toLocaleTimeString();

    return (
        <div
            style={{
                position: "absolute",
                bottom: 30,
                left: "-50px",
                background: "white",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                minWidth: "170px",
                zIndex: 10
            }}
        >
            <div><b>Velocidade:</b> {!spd ? 0 : spd} km/h</div>
            <div><b>Data:</b> {formattedDate} às {formattedTime}</div>
        </div>
    );
};

class GoogleMapsRoute extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLocation: {
                lat: -23.57,
                lng: -46.68,
            },
            selectedMarker: null,
            map: null,
            maps: null,
            polyline: null
        };
    }

    handleMarkerClick = (index) => {
        this.setState({ selectedMarker: index });
    };

    handleMapClick = () => {
        this.setState({ selectedMarker: null });
    };

    handleApiLoaded = ({ map, maps }) => {
        this.setState({ map, maps }, this.drawPolyline);
    };

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.map &&
            this.state.maps &&
            prevProps.locations !== this.props.locations
        ) {
            this.drawPolyline();
        }
    }

    drawPolyline = () => {
        const { map, maps, polyline } = this.state;
        const locations = this.props.locations || [];

        if (!map || !maps) return;

        // Remove polyline anterior
        if (polyline) {
            polyline.setMap(null);
        }

        // Cria nova polyline
        const path = locations.map(loc => ({ lat: loc.lat_value, lng: loc.lng_value }));
        const newPolyline = new maps.Polyline({
            path,
            geodesic: true,
            strokeColor: "#1976D2",
            strokeOpacity: 0.8,
            strokeWeight: 4
        });
        newPolyline.setMap(map);

        this.setState({ polyline: newPolyline });
    };

    render() {
        const locations = this.props.locations || [];

        return (
            <div>
                <div style={{ height: "400px", width: "100%" }}>
                    <GoogleMapReact
                        bootstrapURLKeys={{
                            key: "AIzaSyDN3UVIMYb0l_DCSkM6DwSnD6Ow3prkWZI"
                        }}
                        defaultCenter={this.state.currentLocation}
                        defaultZoom={this.props.defaultZoom || 9}
                        center={this.props.center || this.state.currentLocation}
                        yesIWantToUseGoogleMapApiInternals
                        onClick={this.handleMapClick}
                        onGoogleApiLoaded={this.handleApiLoaded}
                    >
                        {locations.map((loc, idx) => (
                            <div
                                key={idx}
                                lat={loc.lat}
                                lng={loc.lng}
                                style={{ position: "relative" }}
                            >
                                <Marker onClick={() => this.handleMarkerClick(idx)} />
                                {this.state.selectedMarker === idx && (
                                    <InfoWindow spd={loc.spd_value} dt={loc.dt_value} />
                                )}
                            </div>
                        ))}
                        {this.props.children}
                    </GoogleMapReact>
                </div>
            </div>
        );
    }
}

export default GoogleMapsRoute;